<template>
  <div>
    <span v-if='false'><b>Search</b> {{searchText}}, <b>Current</b> {{optionSelected}}, <b>Results</b> {{options}}</span>
    <v-autocomplete
      @update:search-input='search' no-filter
      :items='options' item-text='name' item-value='xid' return-object
      :loading='loading'
      :value='optionSelected'
      @change='change' clearable
      outlined color='blue'
      placeholder='Add a customer...'
      :no-data-text='noDataText'
      hide-details
      prepend-inner-icon='mdi-account-group' @click:prepend-inner='clickIcon'
      label='Customer'
    >
    </v-autocomplete>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>

<script>
import { /* mapGetters, */  mapActions } from 'vuex';
export default {
  name: 'CustomerSelector',
  components: {},
  props: {
    value: { type: Object, required: false, default: null },
  },
  data(){
    return {
      optionSelected: null,
      options: [],
      searchText: null,
      loading: false,
    }
  },
  watch: {
    value: {
        handler(newValue){
        this.optionSelected = newValue;
        this.options = newValue !== null ? [newValue] : [];
      },
      immediate: true
    }
  },
  computed: {
    noDataText(){
      if(this.loading) return "Searching...";
      return "No search results";
    }
  },
  methods: {
    ...mapActions("API", ["API"]),
    ...mapActions("UI", ["ALERT", "NAVIGATE"]),

    search(search){
      if(!search) return;
      if(search === this.optionSelected?.name) return;
      this.searchText = search;
      this.loading = true;
      this.API({method: 'POST', endpoint: `search/customers`, data: { search }, autosave: 250 })
      .then(results => {
        this.options = [
          ...(this.optionSelected ? [this.optionSelected] : []),
          ...results
        ];
      })
      .finally(()=>{ this.loading = false; })
    },

    change(newSelection){
      this.optionSelected = newSelection;
      this.$emit('change', newSelection);
    },

    clickIcon(){
      if(!this.optionSelected)
        this.ALERT({ title: 'Customer', message: 'No customer selected.' });
      else
        this.NAVIGATE(`/dash/crm/${this.optionSelected.xid}`);
    }

  },
  mounted(){
  }
}
</script>
